export const translations = {
  ru: {
    // Header
    home: "Главная",
    news: "Новости",
    library: "Библиотека",
    contacts: "Контакты",
    about: "О нас",
    admin: "Админ",
    login: "Войти",
    logout: "Выйти",
    profile: "Профиль",
    
    // Common
    search: "Поиск...",
    readMore: "Читать далее",
    categories: "Категории",
    allCategories: "Все категории",
    today: "Сегодня",
    yesterday: "Вчера",
    viewMode: "Вид",
    
    // Profile
    profileTitle: "Профиль пользователя",
    changeAvatar: "Изменить фото",
    save: "Сохранить",
    cancel: "Отмена",
    edit: "Редактировать",
    name: "Имя (ФИО)",
    email: "Email",
    officialProfile: "Официальный профиль",
    
    // Admin
    adminPanel: "Панель администратора",
    accessDenied: "Доступ запрещен",
    create: "Создать",
    delete: "Удалить",
    actions: "Действия",
    donations: "Пожертвования",
    soon: "Скоро",
    privacyPolicy: "Политика конфиденциальности",
    aboutProject: "О проекте",
    footerDesc: "КыргызЭйд — общественный фонд, объединяющий библиотеку, новостной портал и благотворительную платформу для поддержки нуждающихся.",
    navigation: "Навигация",
    info: "Информация",
    rights: "Все права защищены",

    // Home Page
    libraryHeroTitle: "Электронная библиотека",
    libraryHeroDesc: "Тысячи книг доступны бесплатно",
    goToLibrary: "Перейти →",
    newsTitle: "Новости",
    newsSearchPlaceholder: "Поиск новостей...",
    newsLoading: "Загрузка новостей...",
    newsNotFound: "Новости не найдены",
    breakingNews: "Срочно",
    featuredNews: "Важное",
    categoryAll: "Все",
    viewsCount: "👁", 

    // News Page
    newsSubtitle: "Актуальные новости и события",
    backToNews: "← Вернуться к новостям",
    allNews: "← Все новости",
    author: "Автор",
    editorial: "Редакция",
    gallery: "Галерея",
    writeComment: "Написать комментарий...",
    send: "Отправить",
    loginToComment: "Войдите, чтобы оставить комментарий",
    loginToLike: "Войдите, чтобы лайкнуть новость",
    commentPosted: "Комментарий отправлен",
    errorPosting: "Ошибка при отправке",

    // Library Page
    libraryTitle: "Библиотека",
    librarySubtitle: "Электронные книги различных жанров",
    searchBooks: "Поиск книг, авторов...",
    gridView: "Сетка",
    listView: "Список",
    allGenres: "Все жанры",
    noBooks: "Книг не найдено",
    loading: "Загрузка...",
    errorLoading: "Ошибка загрузки библиотеки",
    recommended: "Рекомендуем",
    yearFrom: "Год от",
    yearTo: "Год до",
    apply: "Применить",

    // Donations Page
    donationsTitle: "Благотворительность",
    donationsSubtitle: "Платформа для помощи тем, кто действительно в ней нуждается",
    devNoticeTitle: "Раздел находится в разработке",
    devNoticeText: "Мы работаем над созданием прозрачной и надежной платформы для благотворительных сборов. Скоро здесь появится возможность помогать людям, которые действительно нуждаются в поддержке.",
    missionTitle: "Наша миссия",
    missionText: "Создать платформу, где каждый сможет помочь нуждающимся людям с полной уверенностью в прозрачности и честности процесса.",
    whatWillBeTitle: "Что будет на платформе",
    featVerified: "Проверенные сборы",
    featVerifiedDesc: "Каждая история проходит тщательную проверку нашей командой.",
    featTransparent: "Полная прозрачность",
    featTransparentDesc: "Вы будете видеть, сколько собрано средств и куда они направлены.",
    featSafe: "Безопасные платежи",
    featSafeDesc: "Защищенные способы оплаты через проверенные платежные системы.",
    featReports: "Отчеты и обновления",
    featReportsDesc: "Регулярные обновления о состоянии здоровья людей, которым вы помогли.",
    featControl: "Контроль средств",
    featControlDesc: "Средства переводятся только после подтверждения необходимости.",
    featSupport: "Поддержка 24/7",
    featSupportDesc: "Команда поддержки всегда на связи.",
    whoWeHelpTitle: "Кому мы помогаем",
    catSick: "Больные дети и взрослые",
    catSickDesc: "Операции, лечение, реабилитация тяжелых заболеваний",
    catElderly: "Пожилые люди",
    catElderlyDesc: "Медицинская помощь, лекарства, уход",
    catFamily: "Многодетные семьи",
    catFamilyDesc: "Помощь в трудной жизненной ситуации",
    catDisabled: "Люди с инвалидностью",
    catDisabledDesc: "Протезы, инвалидные коляски, реабилитация",
    trustTitle: "Почему нам доверяют",
    trustPersonal: "Личная проверка",
    trustDocs: "Проверка документов",
    trustDirect: "Прямая передача средств",
    trustPublic: "Публичная отчетность",
    notifyTitle: "Хотите быть в курсе запуска?",
    notifyText: "Оставьте свой email, и мы сообщим вам, когда платформа будет готова.",
    notifyButton: "Уведомить меня",
    orWriteUs: "Или напишите нам на",
    contactQuestions: "По вопросам благотворительности и сотрудничества:",

    // About Page
    aboutHeroSubtitle: "Общественный фонд \"КыргызЭйд\" — объединяем знания и помогаем людям",
    missionSectionTitle: "Наша миссия",
    missionSectionText: "Создать универсальную платформу, которая объединяет образовательные ресурсы, актуальную информацию и возможность помогать нуждающимся.",
    whatWeDoTitle: "Что мы делаем",
    eLibrary: "Электронная библиотека",
    eLibraryDesc: "Бесплатный доступ к тысячам книг: художественная литература, учебники, научные труды.",
    newsPortal: "Новостной портал",
    newsPortalDesc: "Актуальные новости Кыргызстана и мира, прошедшие проверку на достоверность.",
    charityPlat: "Благотворительность",
    charityPlatDesc: "Проверенные сборы для людей, которым действительно нужна помощь.",
    valuesTitle: "Наши ценности",
    valAccess: "Доступность",
    valAccessDesc: "Все материалы библиотеки бесплатны для пользователей",
    valReliability: "Достоверность",
    valReliabilityDesc: "Проверка всех новостей и благотворительных сборов",
    valTransparency: "Прозрачность",
    valTransparencyDesc: "Открытая информация о деятельности фонда",
    valQuality: "Качество",
    valQualityDesc: "Тщательный отбор материалов и контента",
    achievementsTitle: "Наши достижения",
    statBooks: "Книг в библиотеке",
    statNews: "Новостей опубликовано",
    statUsers: "Активных пользователей",
    statYears: "Лет работы (с 2016)",
    historyTitle: "История проекта",
    hist2016: "Основание фонда",
    hist2016Desc: "Создан Общественный фонд \"КыргызЭйд\"",
    hist2018: "Запуск библиотеки",
    hist2018Desc: "Открыта электронная библиотека",
    hist2021: "Новостной портал",
    hist2021Desc: "Добавлен раздел новостей",
    hist2026: "Полный редизайн",
    hist2026Desc: "Обновлена платформа, добавлен раздел благотворительности",
    joinUsTitle: "Присоединяйтесь к нам!",
    joinUsText: "Станьте частью сообщества, которое делает мир лучше через знания и взаимопомощь.",
    readBooksBtn: "Читать книги",
    readNewsBtn: "Читать новости",

    // Contacts Page
    contactsTitle: "Свяжитесь с нами",
    contactsSubtitle: "Мы всегда рады вашим вопросам, предложениям и отзывам",
    generalQuestions: "Общие вопросы",
    privacyQuestions: "Вопросы о данных",
    businessOffers: "Деловые предложения",
    writeUsTitle: "Напишите нам",
    formDesc: "Заполните форму, и мы ответим вам в течение 24 часов",
    yourName: "Ваше имя *",
    subject: "Тема обращения *",
    message: "Сообщение *",
    sendSuccess: "Ваше сообщение успешно отправлено! Мы свяжемся с вами в ближайшее время.",
    sending: "Отправка...",
    sendMessage: "Отправить сообщение",
    faqTitle: "Часто задаваемые вопросы",
    socialTitle: "Мы в социальных сетях",
    contactPhoneNote: "Пн-Пт, 9:00-18:00",
    contactAddress: "г. Бишкек, Кыргызская Республика",

    // Book Detail
    bookDetails: "О книге",
    bookDownload: "Скачать",
    bookRead: "Читать онлайн",
    bookPages: "Страниц",
    bookYear: "Год издания",
    bookPublisher: "Издательство",
    bookISBN: "ISBN",
    bookFormat: "Формат",
    bookLanguage: "Язык",
    bookAuthors: "Авторы",
    bookDescription: "Описание",
    bookReviews: "Отзывы и обсуждение",
    bookNoReviews: "Пока нет отзывов. Будьте первыми!",
    bookAddReview: "Оставить отзыв",
    bookYourReview: "Ваш отзыв",
    bookSubmitReview: "Отправить",
    bookLoginToReview: "Войдите, чтобы оставить отзыв",
    bookSimilar: "Похожие книги",
    bookViews: "Просмотров",
    bookDownloads: "Скачиваний",
  },
  ky: {
    // Header
    home: "Башкы бет",
    news: "Жаңылыктар",
    library: "Китепкана",
    contacts: "Байланыш",
    about: "Биз жөнүндө",
    admin: "Админ",
    login: "Кирүү",
    logout: "Чыгуу",
    profile: "Профиль",
    
    // Common
    search: "Издөө...",
    readMore: "Кененирээк",
    categories: "Категориялар",
    allCategories: "Бардык категориялар",
    today: "Бүгүн",
    yesterday: "Кечээ",
    viewMode: "Көрүнүш",
    
    // Profile
    profileTitle: "Колдонуучунун профили",
    changeAvatar: "Сүрөттү өзгөртүү",
    save: "Сактоо",
    cancel: "Жокко чыгаруу",
    edit: "Өзгөртүү",
    name: "Аты-жөнү",
    email: "Электрондук почта",
    officialProfile: "Расмий профиль",
    
    // Admin
    adminPanel: "Администратор панели",
    accessDenied: "Кирүүгө укук жок",
    create: "Жаратуу",
    delete: "Өчүрүү",
    actions: "Аракеттер",
    donations: "Кайрымдуулук",
    soon: "Жакында",
    privacyPolicy: "Купуялык саясаты",
    aboutProject: "Долбоор жөнүндө",
    footerDesc: "КыргызЭйд — муктаждарга жадам берүү үчүн китепкананы, жаңылыктар порталын жана кайрымдуулук платформасын бириктирген коомдук фонд.",
    navigation: "Навигация",
    info: "Маалымат",
    rights: "Бардык укуктар корголгон",

    // Home Page
    libraryHeroTitle: "Электрондук китепкана",
    libraryHeroDesc: "Миңдеген китептер акысыз",
    goToLibrary: "Өтүү →",
    newsTitle: "Жаңылыктар",
    newsSearchPlaceholder: "Жаңылыктарды издөө...",
    newsLoading: "Жаңылыктар жүктөлүүдө...",
    newsNotFound: "Жаңылыктар табылган жок",
    breakingNews: "Шашылыш",
    featuredNews: "Маанилүү",
    categoryAll: "Баары",
    viewsCount: "👁",

    // News Page
    newsSubtitle: "Актуалдуу жаңылыктар жана окуялар",
    backToNews: "← Жаңылыктарга кайтуу",
    allNews: "← Бардык жаңылыктар",
    author: "Автор",
    editorial: "Редакция",
    gallery: "Галерея",
    writeComment: "Комментарий жазуу...",
    send: "Жөнөтүү",
    loginToComment: "Комментарий калтыруу үчүн кириңиз",
    loginToLike: "Жаңылыкты жактыруу үчүн кириңиз",
    commentPosted: "Комментарий жөнөтүлдү",
    errorPosting: "Жөнөтүүдө ката кетти",

    // Library Page
    libraryTitle: "Китепкана",
    librarySubtitle: "Ар кандай жанрдагы электрондук китептер",
    searchBooks: "Китептерди, авторлорду издөө...",
    gridView: "Торчо",
    listView: "Тизме",
    allGenres: "Бардык жанрлар",
    noBooks: "Китептер табылган жок",
    loading: "Жүктөлүүдө...",
    errorLoading: "Китепкананы жүктөөдө ката кетти",
    recommended: "Сунуштайбыз",
    yearFrom: "Жыл (баштап)",
    yearTo: "Жыл (чейин)",
    apply: "Колдонуу",

    // Donations Page
    donationsTitle: "Кайрымдуулук",
    donationsSubtitle: "Муктаж болгондорго жардам берүү платформасы",
    devNoticeTitle: "Бөлүм иштелип чыгууда",
    devNoticeText: "Биз кайрымдуулук чогултуу үчүн ачык жана ишенимдүү платформа түзүүнүн үстүндө иштеп жатабыз.",
    missionTitle: "Биздин миссия",
    missionText: "Муктаж болгондорго жардам берүү үчүн ачык жана чынчыл платформа түзүү.",
    whatWillBeTitle: "Платформада эмне болот",
    featVerified: "Текшерилген жыйымдар",
    featVerifiedDesc: "Ар бир тарых биздин команда тарабынан кылдат текшерилет.",
    featTransparent: "Толук ачыктык",
    featTransparentDesc: "Сиз чогулган каражаттардын көлөмүн жана кайда багытталганын көрө аласыз.",
    featSafe: "Коопсуз төлөмдөр",
    featSafeDesc: "Текшерилген төлөм системалары аркылуу корголгон төлөмдөр.",
    featReports: "Отчеттор жана жаңылыктар",
    featReportsDesc: "Сиз жардам берген адамдардын ден соолугу тууралуу үзгүлтүксүз маалымат.",
    featControl: "Каражаттарды көзөмөлдөө",
    featControlDesc: "Каражаттар муктаждык тастыкталгандан кийин гана которулат.",
    featSupport: "Колдоо 24/7",
    featSupportDesc: "Колдоо тобу ар дайым байланышта.",
    whoWeHelpTitle: "Биз кимге жардам беребиз",
    catSick: "Оорулуу балдар жана чоңдор",
    catSickDesc: "Операциялар, дарылоо, оор ооруларды реабилитациялоо",
    catElderly: "Карылар",
    catElderlyDesc: "Медициналык жардам, дары-дармектер, кароо",
    catFamily: "Көп балалуу үй-бүлөлөр",
    catFamilyDesc: "Оор турмуштук кырдаалда жардам",
    catDisabled: "Мүмкүнчүлүгү чектелген адамдар",
    catDisabledDesc: "Протездер, майыптар коляскалары, реабилитация",
    trustTitle: "Эмне үчүн бизге ишенишет",
    trustPersonal: "Жеке текшерүү",
    trustDocs: "Документтерди текшерүү",
    trustDirect: "Түз каражат которуу",
    trustPublic: "Ачык отчеттуулук",
    notifyTitle: "Ишке киришүүдөн кабардар болгуңуз келеби?",
    notifyText: "Электрондук почтаңызды калтырыңыз, биз сизге кабарлайбыз.",
    notifyButton: "Мага кабарлоо",
    orWriteUs: "Же бизге жазыңыз",
    contactQuestions: "Кайрымдуулук жана кызматташуу боюнча суроолор:",

    // About Page
    aboutHeroSubtitle: "\"КыргызЭйд\" коомдук фонду — билимди бириктирип, адамдарга жардам беребиз",
    missionSectionTitle: "Биздин миссия",
    missionSectionText: "Муктаж болгондорго жардам берүү жана билим берүү ресурстарын бириктирген универсалдуу платформа түзүү.",
    whatWeDoTitle: "Биз эмне кылабыз",
    eLibrary: "Электрондук китепкана",
    eLibraryDesc: "Миңдеген китептерге акысыз мүмкүнчүлүк: адабият, окуу китептери, илимий эмгектер.",
    newsPortal: "Жаңылыктар порталы",
    newsPortalDesc: "Кыргызстандын жана дүйнөнүн актуалдуу, такталган жаңылыктары.",
    charityPlat: "Кайрымдуулук",
    charityPlatDesc: "Чындап жардамга муктаж адамдар үчүн текшерилген жыйымдар.",
    valuesTitle: "Биздин баалуулуктар",
    valAccess: "Жеткиликтүүлүк",
    valAccessDesc: "Китепкананын бардык материалдары колдонуучулар үчүн акысыз",
    valReliability: "Ишенимдүүлүк",
    valReliabilityDesc: "Бардык жаңылыктарды жана кайрымдуулук жыйымдарын текшерүү",
    valTransparency: "Ачыктык",
    valTransparencyDesc: "Фонддун ишмердүүлүгү жөнүндө ачык маалымат",
    valQuality: "Сапат",
    valQualityDesc: "Материалдарды жана мазмунду кылдат тандоо",
    achievementsTitle: "Биздин жетишкендиктер",
    statBooks: "Китепканада китептер",
    statNews: "Жарыяланган жаңылыктар",
    statUsers: "Ауттуу колдонуучулар",
    statYears: "Иштеген жылдар (2016-жылдан)",
    historyTitle: "Долбоордун тарыхы",
    hist2016: "Фонддун негизделиши",
    hist2016Desc: "\"КыргызЭйд\" коомдук фонду түзүлдү",
    hist2018: "Китепкананын ачылышы",
    hist2018Desc: "Электрондук китепкана ачылды",
    hist2021: "Жаңылыктар порталы",
    hist2021Desc: "Жаңылыктар бөлүмү кошулду",
    hist2026: "Толук редизайн",
    hist2026Desc: "Платформа жаңыланып, кайрымдуулук бөлүмү кошулду",
    joinUsTitle: "Бизге кошулуңуз!",
    joinUsText: "Билим жана өз ара жардам аркылуу дүйнөнү жакшыртуучу коомчулуктун бир бөлүгү болуңуз.",
    readBooksBtn: "Китеп окуу",
    readNewsBtn: "Жаңылыктарды окуу",

    // Contacts Page
    contactsTitle: "Биз менен байланышыңыз",
    contactsSubtitle: "Биз сиздин суроолоруңузга жана сунуштарыңызга ар дайым кубанычтабыз",
    generalQuestions: "Жалпы суроолор",
    privacyQuestions: "Маалыматтар боюнча суроолор",
    businessOffers: "Ишкердик сунуштар",
    writeUsTitle: "Бизге жазыңыз",
    formDesc: "Форманы толтуруңуз, биз сизге 24 сааттын ичинде жооп беребиз",
    yourName: "Сиздин атыңыз *",
    subject: "Кайрылуунун темасы *",
    message: "Билдирүү *",
    sendSuccess: "Сиздин билдирүүңүз ийгиликтүү жөнөтүлдү!",
    sending: "Жөнөтүлүүдө...",
    sendMessage: "Билдирүү жөнөтүү",
    faqTitle: "Көп берилүүчү суроолор",
    socialTitle: "Биз социалдык тармактарда",
    contactPhoneNote: "Дш-Жм, 9:00-18:00",
    contactAddress: "Бишкек ш., Кыргыз Республикасы",

    // Book Detail
    bookDetails: "Китеп жөнүндө",
    bookDownload: "Жүктөп алуу",
    bookRead: "Онлайн окуу",
    bookPages: "Беттер",
    bookYear: "Чыккан жылы",
    bookPublisher: "Басмакана",
    bookISBN: "ISBN",
    bookFormat: "Форматы",
    bookLanguage: "Тили",
    bookAuthors: "Авторлор",
    bookDescription: "Баяндама",
    bookReviews: "Пикирлер жана талкуу",
    bookNoReviews: "Пикирлер жок. Биринчи болуп жазыңыз!",
    bookAddReview: "Пикир калтыруу",
    bookYourReview: "Сиздин пикир",
    bookSubmitReview: "Жөнөтүү",
    bookLoginToReview: "Пикир калтыруу үчүн кириңиз",
    bookSimilar: "Окшош китептер",
    bookViews: "Көрүүлөр",
    bookDownloads: "Жүктөөлөр",
  }
};
